<!-- prettier-ignore -->

<ion-header class="login-header">
    <ion-toolbar class="tool-bar-login">
        <span>{{'Inicia sesión' | translate}}</span>
        <ion-icon (click)="dismissModal()" name="close"></ion-icon>
    </ion-toolbar>
</ion-header>

<ion-content class="login-modal">

    <form class="login-form" [formGroup]="loginForm" (ngSubmit)="login()">
        <p>{{'¡Te damos la bienvenida a Cicerone!' | translate}}</p>
        <div class="form-group-login" >
            <label class="labels">
                <span>{{'Correo electrónico' | translate}}</span> *
            </label>
            <div class="divInputStyle">
                <input class="inputs-pdf" autocomplete="off" [type]="'text'" (focusin)="focusin($event)" formControlName="email" />
            </div>
        </div>
        <div class="form-group-login" >
            <label class="labels">
                <span>{{'Contraseña' | translate}}</span> *
            </label>
            <div class="divInputStyle">
                <input class="inputs-pdf" autocomplete="off" [type]="passwordType" (focusin)="focusin($event)" formControlName="password" />
                <ion-icon (click)="showPassword()" class="show-button" name="eye-off"></ion-icon>
            </div>
        </div>

        <div class="action-wrapper">
            <div class="action-wrapper__remember">
                <span>{{'Recordarme' | translate}}</span>
                <div>
                    <input #input type="checkbox" id="input-switch" formControlName="remember" />
                    <label id="label-switch" for="input-switch">Toggle</label>
                </div>
            </div>
            <span class="action-wrapper__forget" (click)="recoverPassword()">{{'He olvidado mi contraseña' | translate}}</span>
        </div>
        
        <button type="submit" class="submit-button">{{'Iniciar sesión' | translate}}</button>

        <div class="action-divider">
            <hr>
            <span>{{'o' | translate}}</span>
            <hr>
        </div>
        
        <button type="button" (click)="register()" class="submit-button">{{'Regístrate' | translate}}</button>
    </form>

</ion-content>